import Loader from "pages/Loader"
import React, { useState } from "react"
import {
  Alert,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
} from "reactstrap"
import logo from "../../assets/images/Logo.png"
import { notification } from "antd"
import { IoMdWarning } from "react-icons/io"
import axios from "axios"
import ConfigUrl from "../../config"
import secureLocalStorage from "react-secure-storage"
import { SiTicktick } from "react-icons/si"
import { useNavigate } from "react-router-dom"

const ResetPassword = () => {
  const Email = secureLocalStorage.getItem("UserEmail")

  const [Loading, setLoading] = useState(false)
  const [Password, setPassword] = useState("")
  const [CPassword, setCPassword] = useState("")
  const [forgetError, setforgetError] = useState("")
  const navigate = useNavigate()

  const handleSubmit = async e => {
    e.preventDefault()
    if (Password === "" && CPassword === "") {
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pr-10">
              <IoMdWarning className="text-danger" size={22} />
            </div>
            <div>Please enter both passwords</div>
          </div>
        ),
      })
    } else if (Password !== CPassword) {
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pr-10">
              <IoMdWarning className="text-danger" size={22} />
            </div>
            <div>
              Password & Confirm Password doesn't match. Please check again !
            </div>
          </div>
        ),
      })
    } else {
      setLoading(true)
      try {
        const response = await axios.post(
          `${ConfigUrl.apiurl}/auth/user/reset-password`,
          {
            email: Email,
            password: Password,
          }
        )
        if (response?.data?.success === true) {
          setLoading(false)
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-10">
                  <SiTicktick className="text-success" size={22} />
                </div>
                <div>Password reset successfully.</div>
              </div>
            ),
            description: response?.data?.message,
          })
          secureLocalStorage.removeItem("tempOTP")
          secureLocalStorage.removeItem("UserEmail")
          setTimeout(() => {
            navigate(`${ConfigUrl.appurl}login`)
          }, 1000)
        } else {
          setLoading(false)
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-10">
                  <IoMdWarning className="text-danger" size={22} />
                </div>
                <div>Opps! Something went wrong.</div>
              </div>
            ),
            description: response?.data?.message,
          })
        }
      } catch (e) {
        setLoading(false)
        console.log(e.response?.data)
      }
    }
  }

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <div className="account-pages">
        <Container>
          <Row className="justify-content-center">
            <Col xl={7}></Col>
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={6}>
                      <div className="text-primary p-4">
                        <h5 className="text-dark">Reset Password</h5>
                        <p className="mb-0 text-dark">Set your new password</p>
                      </div>
                    </Col>
                    <Col className="col-6 p-2 d-flex justify-content-end pe-3">
                      <div className=" profile-user-wid ">
                        <span className="avatar-title rounded-4 px-1 bg-light">
                          <img src={logo} alt="" className="w-100" />
                        </span>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div className="p-2">
                    {/* {forgetError && forgetError ? (
                            <Alert color="danger" style={{ marginTop: "13px" }}>
                                {forgetError}
                            </Alert>
                            ) : null}
                            {forgetSuccessMsg ? (
                            <Alert color="success" style={{ marginTop: "13px" }}>
                                {forgetSuccessMsg}
                            </Alert>
                            ) : null} */}

                    <Form className="form-horizontal" onSubmit={handleSubmit}>
                      <div className="my-3">
                        <Label className="form-label">
                          New Password <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="password"
                          className="form-control"
                          placeholder="Enter Password"
                          type="password"
                          onChange={e => setPassword(e.target.value)}
                          value={Password || ""}
                          required
                        />
                      </div>
                      <div className="my-3">
                        <Label className="form-label">
                          Confirm Password{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="cpassword"
                          className="form-control"
                          placeholder="Enter Password"
                          type="password"
                          onChange={e => setCPassword(e.target.value)}
                          value={CPassword || ""}
                          required
                        />
                      </div>
                      <div className="my-3 text-center">
                        <button
                          className="btn btn-primary w-100 mt-3"
                          type="submit"
                        >
                          Reset Password
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ResetPassword
